export default {
  title: "Modèles de calcul",
  filter: {
    name: "Nom du modèle",
    namePlaceholder: "Veuillez saisir le nom du modèle",
    type: "Type de modèle",
    typePlaceholder: "Veuillez sélectionner le type de modèle",
  },
  table: {
    name: "Nom du modèle",
    type: "Type",
    createdAt: "Créé le",
    actions: "Actions",
    single: "Calcul unique",
    batch: "Calcul groupé",
  },
  action: {
    edit: "Modifier le nom",
    use: "Utiliser",
  },
  modal: {
    editTitle: "Modifier le nom du modèle",
    nameLabel: "Nom du modèle",
    namePlaceholder: "Veuillez saisir le nom du modèle",
    nameRequired: "Veuillez saisir le nom du modèle",
  },
  deleteConfirm: {
    title: "Supprimer le modèle",
    content: "Êtes-vous sûr de vouloir supprimer ce modèle ?",
  },
  message: {
    fetchFailed: "Échec de la récupération de la liste des modèles",
    updateSuccess: "Nom du modèle mis à jour avec succès",
    updateFailed: "Échec de la mise à jour",
    deleteSuccess: "Modèle supprimé avec succès",
  },
};
